import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { AppConfigService } from "../../../core-ui";
import { ErrorPageCode } from "../../../app/app.enums";

export const redirectGuard: CanActivateFn = (route, state): boolean => {
  const config = inject(AppConfigService);

  const code = route.paramMap.get('code');
  if (code === ErrorPageCode.PAGE_NOT_FOUND && config.pageNotFoundRedirectURL) {
    window.location.href = config.pageNotFoundRedirectURL;
    return false;
  }
  return true;
};
